export default "__VITE_ASSET__B51ShiXs__"